/**
 * @Author:
 * @Description:
 * @DateTime: Created in 10:50 2020/10/8
 */

import iView,{Message, Notice, MessageConfig,NoticeConfig,ModalInstance} from 'lb-iview'

const IView: any =iView

const notice: Notice = IView.Notice
const message: Message = IView.Message
const modal: ModalInstance = IView.Modal

export class Toast {
	/**
	 * 成功提示
	 * @param {string} msg
	 * @param {} config
	 */
	static success (msg: string, config?: MessageConfig) {
		message.success({
			content: msg,
			...config
		})
	}

	/**
	 * 警告提示
	 * @param {string} msg
	 * @param {} config
	 */
	static warning(msg: string, config?: NoticeConfig) {
		notice.warning({
			desc: msg,
			...config
		})
	}

	/**
	 * 错误提示
	 * @param {string} msg
	 * @param {} config
	 */
	static error(msg: string, config?: NoticeConfig) {
		notice.error({
			desc: msg,
			...config
		})
	}

	/**
	 * 确认
	 * @param title
	 * @param subTitle
	 * @returns {Promise}
	 */
	static async confirm(title='删除',subTitle='请确认是否删除') {
		return new Promise((resolve, reject) => {
			// 提示框
			modal.confirm({
				title: title,
				content: subTitle,
				onCancel: () => {
					resolve(false)
				},
				onOk: () => {
					resolve(true)
				}
			})
		})
	}
}
